export const REQUEST_PRODUCTS_PENDING = 'REQUEST_PRODUCTS_PENDING'
export const REQUEST_PRODUCTS_SUCCESS = 'REQUEST_PRODUCTS_SUCCESS'
export const REQUEST_PRODUCTS_FAILED = 'REQUEST_PRODUCTS_FAILED'
export const PRODUCTS_FILTER_UPDATED = 'PRODUCTS_FILTER_UPDATED'
export const SEARCH_FIELD_UPDATED = 'SEARCH_FIELD_UPDATED'
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS'

